import styled, { css } from 'styled-components';

export const Container = styled.div`
    ${({ theme }) => css`
        background-color: ${theme.colors.backgroundColor};
        padding: 0;
        width: 100%;
        height: 100%;
        max-width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    `}
`;
